import React, { FC, useMemo } from 'react';

import { Box, SxProps, Theme, Typography } from '@mui/material';
import { isEmpty } from 'lodash';

const useSxProps = () => {
  return useMemo(() => {
    return {
      root: {
        backgroundColor: (theme: Theme) => theme.palette.background.default,
        border: (theme: Theme) => `1px solid ${theme.palette.borderState.default}`,
        borderRadius: '12px',
        padding: '8px 12px',
        marginLeft: '28px',
      },
    };
  }, []);
};

interface Props {
  sx?: SxProps<Theme>;
  dataTestId?: string;
  content: string | JSX.Element;
  fullWidth?: boolean;
}

const ActivityLogContent: FC<Props> = ({ dataTestId, content, fullWidth, sx }) => {
  const sxProps = useSxProps();

  if (!content) {
    return null;
  }

  if (typeof content === 'string' && isEmpty(content)) {
    return null;
  }

  return (
    <Box sx={{ ...sxProps.root, ...sx }} width={fullWidth ? '100%' : 'fit-content'}>
      {typeof content === 'string' ? (
        <Typography data-testid={dataTestId} variant="body2">
          {content}
        </Typography>
      ) : (
        content
      )}
    </Box>
  );
};

export default ActivityLogContent;
